import {APIClient, getLoggedinUser} from "./api_helper";
import * as url from "./url_helper";
import {DOCUMENT_API, POST_CHANGE_PASSWORD, PUBLIC_DOCUMENT_API, REPORTING_API} from "./url_helper";

const api = new APIClient();

// Gets the logged-in user data from local session
export const getLoggedInUser = () => {
    const user = localStorage.getItem("user");
    if (!user) {
        return null;
    }

    try {
        return JSON.parse(user);
    } catch (error) {
        localStorage.removeItem("user");
        return null;
    }
};

const getLoggedInUserData = () => {
    return getLoggedinUser()?.data || null;
};

const getLoggedInUserValue = (key: string, fallback: any = '') => {
    const userData = getLoggedInUserData();
    return userData?.[key] ?? fallback;
};

export const getLoggedInUserRole = () => {
    return getLoggedInUserValue('role_id', null);
};

export const getLoggedInUserRoleArray = () => {
    const roleId = getLoggedInUserRole();
    return roleId ? [roleId] : [0];
};

export const getLoggedInUserName = () => {
    return getLoggedInUserValue('name', '');
};

export const getLoggedInUserId = () => {
    return getLoggedInUserValue('id', '');
};

export const getLoggedInMerchantId = () => {
    const userData = getLoggedInUserData();

    return userData?.merchant_id
        || userData?.merchant_account?.id
        || userData?.merchant?.id
        || (Number(userData?.role_id) === 3 ? userData?.id : '')
        || '';
};


// //is user is logged in
export const isUserAuthenticated = () => {
    return getLoggedInUser() !== null;
};

// Register Method
export const postRegister = (data: any) => api.create(url.POST_REGISTER, data);

// Login Method
export const postLogin = (data: any) => api.create(url.POST_LOGIN, data);

// postForgetPwd
export const postForgetPwd = (data: any) => api.create(url.POST_PASSWORD_FORGET, data);

// Edit profile
export const postJwtProfile = (data: any) => api.create(url.POST_EDIT_JWT_PROFILE, data);

export const postProfile = (data: any) => api.update(url.POST_EDIT_PROFILE + '/' + data.idx, data);

// Register Method
export const postJwtRegister = (url: string, data: any) => {
    return api.create(url, data)
        .catch(err => {
            var message;
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 404:
                        message = "Sorry! the page you are looking for could not be found";
                        break;
                    case 500:
                        message = "Sorry! something went wrong, please contact our support team";
                        break;
                    case 401:
                        message = "Invalid credentials";
                        break;
                    default:
                        message = err[1];
                        break;
                }
            }
            throw message;
        });
};

// Login Method
export const postJwtLogin = (data: any) => api.create(url.POST_JWT_LOGIN, data);
export const changePasswordApi = (data: any) => api.create(url.POST_CHANGE_PASSWORD, data);
export const postChangePassword = (data: any) => api.create(url.POST_CHANGE_PASSWORD, data);

// postForgetPwd
export const postJwtForgetPwd = (data: any) => api.create(url.POST_JWT_PASSWORD_FORGET, data);

//API Key
export const getAPIKey = () => api.get(url.GET_API_KEY);


//
export const getMerchantDocumentSignatures = (params: any) => api.get(`${url.MERCHANT_API}/document-signatures`, params);
export const getMerchantDocuments = (params: any) => api.get(`${url.MERCHANT_API}/getDocuments`, params);
export const getMerchantDocumentsFailed = (params: any) => api.get(`${url.MERCHANT_API}/getDocumentsFailed`, params);
export const getMerchantDocumentsPending = (params: any) => api.get(`${url.MERCHANT_API}/getDocumentsPending`, params);
export const getMerchantDocumentsOffline = (params: any) => api.get(`${url.MERCHANT_API}/getDocumentsOffline`, params);
export const getMerchantDocument = (documentId: string) => api.get(`${url.MERCHANT_API}/getDocuments/${documentId}`);
export const getMerchantPublicDocument = (documentId: string) => api.get(`${url.PUBLIC_DOCUMENT_API}/${documentId}`);
export const getMerchants = (params: any) => api.get(`${url.MERCHANT_API}`, params);
export const getMerchant = (merchantId: string) => api.get(`${url.MERCHANT_API}/${merchantId}`);
export const getMerchantSelect = () => api.get(`${url.MERCHANT_API}/select`);
export const updateMerchant = (merchantId: string, data: any) => api.update(`${url.MERCHANT_API}/${merchantId}`, data);
export const updateMerchantLogo = (merchantId: string, data: any) => api.update(`${url.MERCHANT_API}/${merchantId}/updateLogo`, data);
export const createMerchant = (data: any) => api.create(`${url.MERCHANT_API}`, data);


export const getMerchantCreditTransactionsApi = (params: any) => api.get(`${url.MERCHANT_API}/credit`,params);
export const getMerchantCreditTransactionApi = (transactionId: string) => api.get(`${url.MERCHANT_API}/credit/${transactionId}`);
export const getMerchantCreditsApi = (merchantId: string) => api.get(`${url.MERCHANT_API}/getCreditsForMerchant/${merchantId}`);
export const getMerchantFromGsisApi = (vatNumber: string) => api.get(`${url.GSIS_API}/getDataForVat/${vatNumber}`);
export const getApiKeyForMerchant = (merchantId: string) => api.get(`${url.MERCHANT_API}/${merchantId}/getApiKeyForMerchant`);
export const createMerchantApiKey = (merchantId: string) => api.create(`${url.MERCHANT_API}/${merchantId}/createApiKeyForMerchant`,null);
export const createMerchantCreditTransactionApi = ( data: any) => api.create(`${url.MERCHANT_API}/credit`, data);
export const updateMerchantCreditTransactionApi = (transactionId: string,data: any) => api.update(`${url.MERCHANT_API}/credit/${transactionId}`, data);
export const deleteMerchantCreditTransactionApi = (transactionId: string) => api.delete(`${url.MERCHANT_API}/credit/${transactionId}`);
export const deleteMerchantApi = (merchantId: string) => api.delete(`${url.MERCHANT_API}/${merchantId}`);


export const getOfflineDocument = (documentId: string) => api.get(`${url.MERCHANT_API}/document-offline/${documentId}`);
export const updateOfflineDocument = (documentId: string, data: any) => api.update(`${url.MERCHANT_API}/document-offline/${documentId}`, data);
export const createOfflineDocument = (data: any) => api.create(`${url.MERCHANT_API}/document-offline`, data);
export const deleteOfflineDocument = (documentId: string) => api.delete(`${url.MERCHANT_API}/document-offline/${documentId}`);


export const getDocumentTypes = (params: any) => api.get(`${url.DOCUMENT_API}/types`, params);
export const getDocumentType = (documentTypeId: string) => api.get(`${url.DOCUMENT_API}/types/${documentTypeId}`);
export const updateDocument = (documentTypeId: string, data: any) => api.update(`${url.DOCUMENT_API}/types/${documentTypeId}`, data);
export const createDocumentType = (data: any) => api.create(`${url.DOCUMENT_API}/types`, data);
export const deleteDocumentType = (documentTypeId: string) => api.delete(`${url.DOCUMENT_API}/types/${documentTypeId}`);

export const getMyDataReferenceTableRows = (table: string, params: any) => api.get(`${url.MYDATA_REFERENCE_TABLES_API}/${table}`, params);
export const getMyDataReferenceTableRow = (table: string, rowId: string) => api.get(`${url.MYDATA_REFERENCE_TABLES_API}/${table}/${rowId}`);
export const createMyDataReferenceTableRow = (table: string, data: any) => api.create(`${url.MYDATA_REFERENCE_TABLES_API}/${table}`, data);
export const updateMyDataReferenceTableRow = (table: string, rowId: string, data: any) => api.update(`${url.MYDATA_REFERENCE_TABLES_API}/${table}/${rowId}`, data);
export const deleteMyDataReferenceTableRow = (table: string, rowId: string) => api.delete(`${url.MYDATA_REFERENCE_TABLES_API}/${table}/${rowId}`);


export const getMerchantCount = (params: any) => api.get(`${url.REPORTING_API}/getMerchantCount`, params);
export const getMerchantInvoiceCount = (params: any) => api.get(`${url.REPORTING_API}/getMerchantInvoiceCount`, params);
export const getMerchantInvoiceFailedCount = (params: any) => api.get(`${url.REPORTING_API}/getMerchantInvoiceFailedCount`, params);
export const getMerchantInvoicePendingCount = (params: any) => api.get(`${url.REPORTING_API}/getMerchantInvoicePendingCount`, params);
export const getUserCount = (params: any) => api.get(`${url.REPORTING_API}/getUserCount`, params);

export const getUsers = (params: any) => api.get(`${url.USER_API}`, params);
export const getUser = (userId: string) => api.get(`${url.USER_API}/${userId}`);
export const updateUser = (userId: string, data: any) => api.update(`${url.USER_API}/${userId}`, data);
export const createUser = (data: any) => api.create(`${url.USER_API}`, data);
export const deleteUser = (userId: string) => api.delete(`${url.USER_API}/${userId}`);
